import api from "../api";

import { CLEAR_MESSAGE, ADD_AD, GET_ADS, UPDATE_ADD } from "./adTypes";
import { GET_ERRORS } from "../errorServices/errorTypes";

export const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_MESSAGE,
  });
};

//add ad
export const AddingAd = (data) => async (dispatch) => {
  await api
    .post("/api/ads/add", data)
    .then((res) => {
      dispatch({
        type: ADD_AD,
        payload: res.data,
      });
    })
    .then(() => {
      dispatch(getAds());
    })
    .catch((err) => {
      // Surface a failed create as an error toast via the shared errors slice,
      // instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};

//add ad
export const UpdatingAd = (data) => async (dispatch) => {
  await api
    .put("/api/ads/update", data)
    .then((res) => {
      dispatch({
        type: UPDATE_ADD,
        payload: res.data,
      });
    })
    .then(() => {
      dispatch(getAds());
    })
    .catch((err) => {
      // Surface a failed update (e.g. 404 not-found) as an error toast via the
      // shared errors slice, instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};

export const getAds = () => async (dispatch) => {
  await api
    .get("/api/ads")
    .then((res) => {
      dispatch({
        type: GET_ADS,
        payload: res.data.reverse(),
      });
    })
    .catch((err) => {
      // Surface a failed fetch as an error toast via the shared errors slice,
      // instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};

// Resolves to true once the delete succeeded, so the screen can confirm it
// (SCRUM-1944); a failed delete still resolves (to undefined) via GET_ERRORS.
export const deleteAd = (id) => async (dispatch) => {
  return api
    .delete(`/api/ads/delete/${id}`)
    .then(() => {
      dispatch(getAds());
      return true;
    })
    .catch((err) => {
      // Surface a failed delete as an error toast via the shared errors slice,
      // instead of an unhandled rejection that shows nothing.
      dispatch({ type: GET_ERRORS, payload: err.response?.data });
    });
};
